import React, { Component } from 'react';
import SelectSpecialties from './components/SelectSpecialties/index';
import CreateSkill from './components/CreateSkill/index';
import CreateQuestion from './components/CreateQuestion/index';

//import 'react-select/dist/react-select.css';


var CreateChangeTest = React.createClass({
  getInitialState: function(){
    var result = {
      open: this.props.change ? true : false,
      error: false,
      test: {
        minTechBall: '',
        minPsiBall: ''
      }
    }

    if(this.props.change){
      result.test = this.props.test;
    }
    return(result);
  },
  handlerOpen: function(){
    var result = {open: true}
    if(!this.props.change){
      this.props.specialties.map((item, i, a)=>{
        if(i == a.length && item.test){
          result.specialtyError = true;
          result.error = true;
        }
      })
    }
    this.setState(result);
  },
  handlerClose: function(){
    if(this.props.change){
      this.props.actionChangeOpen();
    }else{
      this.setState({
        open: false
      });
    }
  },
  handlerOnChage: function(element){
    this.setState({
      [element.target.name]: element.target.value, error: false
    })
  },
  handlerCreate: function(){

    //тут нужно проверить что все поля заполнены
    if(!/^\d+$/.test(this.state.test.minPsiBall) || !/^\d+$/.test(this.state.test.minTechBall)){
      this.setState({
        error: true
      })
      return;
    }


    var data = {
          login : this.props.login,
          pass  : this.props.pass,
          test: this.state.test,
          specialtyId: this.props.change ? this.props.specialty.id : this.state.test.specialti.id
        },
        THIS = this;
    

    delete data.test.specialti;

    var specialties = this.props.specialties;
    for(var item of specialties){
      if(item.id == data.specialtyId){  
        item.test = data.test;
      }
    }

    io.socket.post("/api/createTest", data, function (response){
      if(response.success){
        if(THIS.props.change){
          THIS.props.actionChangeOpen();
        }else{
          THIS.setState({
            open: false
          });
        }
        THIS.props.handlerReloadSpecialties(specialties)
      }else{
        THIS.setState({
          error: true
        })
      }
    });
  },
//   onCheckSelect: function(data){
//     this.setState({specialties: data})
//   },
  onSelectSpecialty: function(data){
    this.setState({test: {
        specialti: data
    }, error: false})
  },
  saveSkills: function(data){
    var test = this.state.test;
    test.skills = data;
    this.setState({test: test, error: false})
  },
  saveQuestion: function(data){
    var test = this.state.test;
    test.questions = data;
    this.setState({test: test, error: false})
  },
  changeMinTechBall: function(e){
    var test = this.state.test;
    test.minTechBall = e.target.value;
    this.setState({test: test, error: false})
  },
  changeMinPsiBall: function(e){
    var test = this.state.test;
    test.minPsiBall = e.target.value;
    this.setState({test: test, error: false})
  },
  render: function(){
    if(this.state.open){
        return(
          <div className={!this.props.change ? this.state.error ? 'UserList error' : 'UserList' : this.state.error ? 'error' : ''}>
                <div className={!this.props.change ? "User" : ""} >
                    <div className={"CreatePanel" + (this.state.error ? ' error' : '')}>
                        
                        {this.props.change ? (
                          <div className="headline">{this.props.specialty.VacancyName}</div>
                        ) : (
                          <SelectSpecialties specialtyError={this.state.specialtyError} activeSpecialti={this.state.test.specialti} onSelectSpecialty={this.onSelectSpecialty} specialties={this.props.specialties} />
                        )}
                        {this.state.test.specialti || this.props.change ? (
                            <div>
                                <CreateSkill saveSkills={this.saveSkills} skills={this.state.test.skills} />
                            </div>
                        ) : null}
                        {this.state.test.skills ? (
                            <div>
                                <CreateQuestion saveQuestion={this.saveQuestion} questions={this.state.test.questions} skills={this.state.test.skills} />
                            </div>
                        ) : null}
                        {this.state.test.questions ? (
                          <div>
                            <input type="text" placeholder="Мин. технический балл" onChange={this.changeMinTechBall} value={this.state.test.minTechBall} />
                            <input type="text" placeholder="Мин. психологический балл"  onChange={this.changeMinPsiBall}  value={this.state.test.minPsiBall} />
                          </div>
                        ) : null}
                        <div className="SelectSpecialtiesOpen" onClick={this.handlerCreate}>{this.props.change ? 'Изменить тест' : 'Создать Тест'}</div>
                        <div className="SelectSpecialtiesOpen" onClick={this.handlerClose}>Закрыть</div>
                    </div>
                </div>
            </div>
            
         
        );
    }else{
        return(
          <div className="CreatePanel">
            <div className="SelectSpecialtiesOpen" onClick={this.handlerOpen}>Создать тест</div>
          </div>
        );
    }
  }
});

export default CreateChangeTest;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/AdminPanel/components/CreatePanelTest/index.jsx
 **/